import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import Ementa from '../../../../components/auth/leis/listar/form_ementa'


function EmentaLeiScreen() {

    return (
        <Fragment>
            <Head titulo="Editando Ementa - Módulo Legislativo" />
            <HeaderLogged />
            <Container>
               <Ementa />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default EmentaLeiScreen;